<template>
    <div class="release">
        <page-title></page-title>
        <el-steps :active="stepActive" finish-status="success" align-center class="steps">
            <el-step title="上传app包"></el-step>
            <el-step title="设置app信息"></el-step>
            <el-step title="完成"></el-step>
        </el-steps>
        <div class="upload-app" v-if="stepActive == 0">
            <el-upload
                class="upload-btn"
                ref="upload"
                drag
                action=""
                :http-request="uploadFile"
                accept=".apk, .ipa"
                v-loading="uploadLoading"
                element-loading-text="正在上传"
                element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(255, 255, 255, 0.8)">
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                <template #tip>
                    <div class="el-upload__tip">
                    只能上传 apk/ipa 文件
                    </div>
                </template>
            </el-upload>
        </div>
        <div class="app-info" v-if="stepActive == 1">
            <div class="app-logo">
                <img :src="appDetail.app_list_data.icon_url" alt="">
                <h3 class="app-name">{{ appDetail.app_list_data.app_name }}</h3>
            </div>
            <el-form label-width="100px" class="app-info-form">
                <el-form-item label="app名称">{{ appDetail.app_list_data.app_name }}</el-form-item>
                <el-form-item label="app版本">{{ appDetail.version_data.version_number }}</el-form-item>
                <el-form-item label="平台">{{ appDetail.app_list_data.app_type }}</el-form-item>
                <el-form-item label="上架">
                    <el-switch :inactive-value="0" :active-value="1" v-model="versionStatus"></el-switch>
                </el-form-item>
                <el-form-item label="更新内容">
                    <el-input type="textarea" rows="4" v-model="versionDesc"></el-input>
                </el-form-item>
            </el-form>
            <div class="app-info-btn">
                <el-button type="primary" class="btn" :loading="saveLoading" @click="updateVersion">保存</el-button>
            </div>
        </div>
        <div class="app-success" v-if="stepActive == 2">
            <i class="iconfont x-yuanxingxuanzhongfill"></i>
            <p>保存成功</p>
            <el-button @click="$router.push('/')" class="btn">返回</el-button>
        </div>
    </div>
</template>
<script>
import pageTitle from '@/components/page-title/index.vue';
export default {
    components: {
        pageTitle
    },
    data() {
        return {
            stepActive: 0, // 步骤
            uploadLoading: false, // 上传loading
            appDetail: {}, // 上传的文件详情
            saveLoading: false, // 保存loading
            versionStatus: 1, // 版本状态 0：下架 1：上架
            versionDesc: null, // 版本描述
        }
    },
    methods: {
        async uploadFile(e) {
            let fd = new FormData();
            let token = localStorage.getItem('token');
            fd.append('app_file', e.file);
            fd.append('token', token);
            this.uploadLoading = true;
            const res = await this.$api.uploadApp(fd);
            this.uploadLoading = false;
            if(res.data.code === 0) {
                this.stepActive = 1;
                this.appDetail = res.data.data;
            } else {
                this.$refs.upload.clearFiles();
                this.$message.error(res.data.msg);
            }
        },
        async updateVersion() { // 更新版本
            this.saveLoading = true;
            const res = await this.$api.updateAppVersion({
                id: this.appDetail.version_data.id,
                status: this.versionStatus,
                version_desc: this.versionDesc,
            });
            this.saveLoading = false;
            if(res.data.code === 0) {
                this.stepActive = 2;
            } else {
                this.$message.error(res.data.msg);
            }
        }
    }
}
</script>
<style lang="scss" scoped>
    .release {
        width: 80%;
        margin: 0 auto;
    }

    .steps {
        margin-top: 40px;
    }

    .upload-app {
        text-align: center;
        margin-top: 40px;

        .upload-btn-wrp {
            display: flex;
            align-items: center;
            justify-content: center;
            margin-top: 20px;
        }

        .upload-submit-btn {
            width: 200px;
        }
    }

    .app-info {
        margin-top: 40px;
        padding-bottom: 40px;

        .app-logo {
            text-align: center;

            img {
                width: 160px;
                height: 160px;
                border-radius: 6px;
                box-shadow: 0 0 10px 0 rgba(0, 0, 0, .1);
            }

            .app-name {
                padding-top: 15px;
                font-size: 28px;
            }
        }

        .app-info-form {
            margin-top: 40px;
        }

        .app-info-btn {
            text-align: center;
            padding-top: 20px;

            .btn {
                width: 200px;
            }
        }
    }

    .app-success {
        text-align: center;
        padding-top: 40px;

        .iconfont {
            font-size: 200px;
            color: #67C23A;
        }

        p {
            padding-top: 10px;
            font-size: 26px;
            font-weight: 700;
        }

        .btn {
            width: 200px;
            margin-top: 20px;
        }
    }
</style>

<style lang="scss">
    .app-info {
        .el-form-item__content {
            font-size: 18px;
        }

        .el-form {
            --el-form-label-font-size: 18px;
        }
    }
</style>